module.exports = __webpack_public_path__ + "static/frustration-40b478376a00ca96f73b96aa53d6dfdd.png";